import React, { FC, useEffect } from 'react';

import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import * as SummaryStyles from './_goldConversionDetails.module.scss';
import { GoldConversionStatusEnum } from '~utils/enums';
import SummaryPDF from './SummaryPDF';
import ReceiptPDF from './ReceiptPDF';
import * as ReceiptStyles from './_goldConversionDetails.module.scss';

const GoldConversionDetails: FC = () => {
    const dispatch = useAppDispatch();
    const goldConversionDraftId = useAppSelector(state => state.gold.goldConversionDraftId);
    const selectedConversion = useAppSelector(state => state.gold.selectedConversion);

    useEffect(() => {
        if (!goldConversionDraftId?.draftId) return;

        dispatch(
            combinedActions.goldGetGoldConversionFinalDraftsSummaryAttempt({
                id: goldConversionDraftId.draftId,
            })
        );
    }, [dispatch, goldConversionDraftId?.draftId]);

    if (!selectedConversion) return null;

    const summaryTable = [
        {
            label: 'Conversion Status',
            value: GoldConversionStatusEnum[selectedConversion.status],
        },
        {
            label: 'Region Name',
            value: selectedConversion.regionName,
        },
        {
            label: 'Branch Name',
            value: selectedConversion.branchName,
        },
        {
            label: 'Branch Code',
            value: selectedConversion.branchCode,
        },
        {
            label: 'Name of Customer/Company Firm/Association',
            value: selectedConversion.customerName,
        },
        {
            label: 'Identification No.',
            value: selectedConversion.idNo,
        },
        {
            label: 'CIF No.',
            value: selectedConversion.CIFNo,
        },
        {
            label: 'Amount',
            value: selectedConversion.amount,
        },
        {
            label: 'Product Converted',
            value: selectedConversion.targetProductName,
        },
        {
            label: 'Conversion Fee',
            value: `RM ${Number(selectedConversion.conversionFee).toFixed(2)}`,
        },
    ];

    const handleSubmitForApproval = () => {
        if (!goldConversionDraftId?.draftId) return;

        dispatch(
            combinedActions.goldCreateGoldConversionAttempt({
                draftId: goldConversionDraftId.draftId,
            })
        );
    };

    const productTableHeader = [
        'Product Name',
        'Price per gram (MYR)',
    ];

    return (
        <div className={SummaryStyles.container}>
            <table className={SummaryStyles['summary-table']}>
                <tbody>
                    {summaryTable.map(item => (
                        <tr key={item.label}>
                            <td>{item.label}</td>
                            <td
                                data-testid={
                                    item.label === 'Amount'
                                        ? 'transaction-summary-quantity'
                                        : undefined
                                }
                            >
                                : {item.value ?? ''}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={SummaryStyles['product-container']}>
                <Text
                    label='Description'
                    isBold
                />

                <table>
                    <tbody>
                        <tr>
                            {productTableHeader.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>

                        {(selectedConversion.description || []).map((item, index) => (
                            <tr key={index}>
                                <td>
                                    {item.originProductName || item.targetProductName || '-'}
                                </td>
                                <td>
                                    {item.pricePerGram
                                        ? Number(item.pricePerGram).toFixed(2)
                                        : '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className={SummaryStyles['button-container']}>
                <div className={ReceiptStyles['button-container']}>
                    <SummaryPDF />

                    <ReceiptPDF />
                </div>
            </div>
        </div>
    );
};

export default GoldConversionDetails;
